(() => {
  const root = document.getElementById('PKFilmHero');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const video = root.querySelector('video');
  const pause = root.querySelector('#PKFilmPause');
  const sound = root.querySelector('#PKFilmSound');
  const seek = root.querySelector('#PKFilmSeek');
  const time = root.querySelector('#PKFilmTime');
  const start = root.querySelector('#PKFilmStart');
  const expand = root.querySelector('#PKFilmFull');
  const playIcon = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m8 5 11 7-11 7Z"/></svg>';
  const pauseIcon = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14M16 5v14"/></svg>';
  let previousOverflow = '';
  let attachedBgm = null;

  function syncAmbient() {
    const bgm = window.PKBgm;
    if (!bgm) return;
    if (!video.muted && !video.paused) bgm.suspend();
    else if (bgm.getState().suspended) bgm.resume().catch(() => {});
  }
  function syncSound() {
    const audible = !video.muted;
    sound.setAttribute('aria-pressed', String(audible));
    sound.title = audible ? 'Turn film sound off' : 'Turn film sound on';
    sound.querySelector('span').textContent = audible ? 'Sound on' : 'Sound off';
    sound.querySelector('svg').innerHTML = audible
      ? '<path d="M11 5 6 9H3v6h3l5 4ZM16 7q8 5 0 10M15 10q3 2 0 4"/>'
      : '<path d="M11 5 6 9H3v6h3l5 4ZM16 9l6 6M22 9l-6 6"/>';
    syncAmbient();
  }
  function syncPlayback() {
    const label = video.paused ? 'Play film' : 'Pause film';
    pause.setAttribute('aria-label', label);
    pause.title = label;
    pause.innerHTML = video.paused ? playIcon : pauseIcon;
    start.hidden = !video.paused;
    syncAmbient();
  }
  function play() {
    const source = video.querySelector('source[data-src]');
    if (source && !source.hasAttribute('src')) {
      source.src = source.dataset.src;
      video.load();
    }
    if (!video.muted && window.PKBgm) window.PKBgm.suspend();
    video.play().catch(() => { syncPlayback(); syncAmbient(); });
  }
  function togglePlayback() {
    if (video.paused) play();
    else video.pause();
  }
  function connectBgm() {
    const bgm = window.PKBgm;
    if (!bgm || attachedBgm === bgm) return;
    attachedBgm = bgm;
    // Choosing background music switches the video back to silent pictures.
    Object.values(bgm.getAudio()).forEach(audio => audio.addEventListener('play', () => {
      if (!video.muted) { video.muted = true; syncSound(); }
    }));
    syncAmbient();
  }
  pause.onclick = togglePlayback;
  start.onclick = play;
  video.addEventListener('click', togglePlayback);
  video.tabIndex = 0;
  video.setAttribute('role', 'button');
  video.setAttribute('aria-label', 'Play or pause film');
  video.addEventListener('keydown', event => {
    if (event.key === ' ' || event.key === 'Enter') { event.preventDefault(); togglePlayback(); }
  });
  sound.onclick = () => {
    if (video.muted && window.PKBgm) window.PKBgm.suspend();
    video.muted = !video.muted;
    if (!video.muted && video.paused) play();
    syncSound();
  };
  video.addEventListener('volumechange', syncSound);
  video.addEventListener('play', syncPlayback);
  video.addEventListener('pause', syncPlayback);
  video.addEventListener('loadedmetadata', () => { seek.max = video.duration; syncPlayback(); });
  video.addEventListener('timeupdate', () => {
    seek.value = video.currentTime;
    const seconds = Math.floor(video.currentTime);
    time.textContent = String(Math.floor(seconds / 60)).padStart(2, '0') + ':' + String(seconds % 60).padStart(2, '0');
  });
  seek.disabled = true;
  video.addEventListener('loadedmetadata', () => { seek.disabled = false; });
  seek.addEventListener('input', () => { if (video.readyState > 0) video.currentTime = Number(seek.value); });
  expand.onclick = () => {
    const open = root.classList.toggle('is-theater');
    if (open) { previousOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; }
    else document.body.style.overflow = previousOverflow;
    expand.setAttribute('aria-pressed', String(open));
    expand.setAttribute('aria-label', open ? 'Exit expanded view' : 'Expand film');
    expand.title = open ? 'Exit expanded view' : 'Expand film';
  };
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && root.classList.contains('is-theater')) expand.click();
  });
  document.addEventListener('pk:bgm:ready', connectBgm);
  document.addEventListener('pk:bgm:context', event => {
    if (event.detail?.context === 'gateway' && !video.paused) video.pause();
  });
  document.addEventListener('pk:bgm:gateway-start', () => { if (!video.paused) video.pause(); });
  video.muted = true;
  syncSound();
  connectBgm();
  syncPlayback();
})();
